import { useEffect, useState } from 'react';
import axios from 'axios';

// Logic duplicated from 'packages/legacy/srcwebapp/hooks/useTargetingSettings'
// TODO: Extract into a common re-usable place out of legacy.
export const useGetErrorCapturingConsent = (siteId: number, isEmpty: boolean): boolean => {
  const [sessionCaptureConsoleConsent, setSessionCaptureConsoleConsent] = useState(false);

  useEffect(() => {
    if (isEmpty) {
      (async () => {
        try {
          const response = await axios.get(`/api/v1/sites/${siteId}/settings/sessions`);
          setSessionCaptureConsoleConsent(response?.data?.session_capture_console_consent === true);
        } catch {
          throw new Error('Request error');
        }
      })();
    }
  }, [siteId, isEmpty]);

  return sessionCaptureConsoleConsent;
};
